import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--password" icon='password'>{ children ? children : 'Forgot Password' }</Button>
}